import $ from 'jquery';
import ImageApp from '../core/app';
import initLog from './log';

const collection = window.C.imageColl;
const imageModel = collection.items;
const collMeta = collection.meta;

const $imageColl = $(`#${collMeta.wrapCollId}`);

const imageApp = new ImageApp($imageColl, {
  data: imageModel,
  buttonExtendSelector: '#imgExtendView',
  thumbBoard: {
    areaWrapper: '.mg_cont',
    board: '#imgList',
    fixedImageDivWidth: 68,
    fixedImageDivHeight: 90
  }
});

resetBoardHeight(imageApp);
toggleLoadingStateOnAjaxRequestStatusChange(imageApp);
imageApp.$app.on('render', function () {
  showEvenThumbs(imageApp);
});
showMoreImagesOnButtonClick(imageApp);
initLog($imageColl, imageApp);

/**
 * log
 * update tenth-2-plugin
 *
 */

function showMoreImagesOnButtonClick(imageApp) {
  const maxClickCnt = 3;
  let disabled = false;
  imageApp.btnExtend.$elem.on('click', function () {
    if (disabled) {
      return;
    }
    disabled = true;
    const appState = imageApp.state;
    const clickCnt = appState.moreBtnClickCnt;

    if (clickCnt < maxClickCnt) {
      appState.moreBtnClickCnt = appState.moreBtnClickCnt + 1;
    } else {
      appState.moreBtnClickCnt = 0;
      changeViewByActionType('extend');
    }

    if (appState.visibleLine === 8) {
      appState.visibleLine = 0;
      window.scrollTo(0, $imageColl.offset().top);
    }
    appState.reachedAjaxCallLimit = clickCnt === maxClickCnt;

    if (imageApp.thumbBoard.thumbnails.length >= 80 || appState.reachedAjaxCallLimit) {
      showEvenThumbs(imageApp);
      disabled = false;
      setButtonViewByClickCount(appState.moreBtnClickCnt, maxClickCnt);
      return;
    }

    imageApp.getMoreData({
      m: 'img',
      req: 'qtotal',
      cnucc: imageApp.state.isUserReportMode ? 1 : null,
      sd: SF.urlParameter.sd || null,
      ed: SF.urlParameter.ed || null,
      lpp: imageApp.thumbBoard.thumbnails.length,
      page: appState.dataPageNum + 1
    }).always(() => {
      disabled = false;
      setButtonViewByClickCount(appState.moreBtnClickCnt, maxClickCnt);
    });
  });
}

function resetBoardHeight(imageApp) {
  imageApp.thumbBoard.$board.height('auto');
}

function changeViewByActionType(actionType) {
  const $extendView = imageApp.btnExtend.$elem;
  const $textWrapper = $extendView.find('span').eq(0);
  switch (actionType) {
    case 'loading':
      $textWrapper.removeClass('inner').text('로딩중...');
      break;
    case 'loading_success':
      $textWrapper.addClass('inner').text('펼쳐보기');
      break;
    case 'extend':
      $extendView.addClass('open').removeClass('close');
      break;
    case 'collapse':
      $extendView.addClass('close').removeClass('open');
      break;
    default:
  }
}

function showEvenThumbs(imageApp) {
  const appState = imageApp.state;
  const thumbnails = imageApp.thumbBoard.thumbnails;
  const lineCnt = appState.visibleLine + 2;

  const showThumbnailsBelowLineCnt = (idx, each) => {
    each.data.hide = (each.data.lineCount) <= lineCnt ? 'N' : 'Y';
  };
  const setDisplayByLineCnt = (idx, each) => {
    each.data.hide === 'Y' ? each.$html.hide() : each.$html.show();
  };

  $.each(thumbnails, showThumbnailsBelowLineCnt);
  $.each(thumbnails, setDisplayByLineCnt);

  appState.visibleLine += 2;
}

function setButtonViewByClickCount(cnt, maxClickCnt) {
  if (cnt === 1) {
    changeViewByActionType('extend');
  } else if (cnt === maxClickCnt) {
    changeViewByActionType('collapse');
  }
}

function toggleLoadingStateOnAjaxRequestStatusChange(imageApp) {
  imageApp.$app.on('load:start', function () {
    changeViewByActionType('loading');
  });

  imageApp.$app.on('load:end', function () {
    changeViewByActionType('loading_success');
  });

}



/** WEBPACK FOOTER **
 ** ./src/IIM/tot/index.js
 **/